<script setup lang="ts">
const collectionsStore = useCollectionsStore()
</script>

<template>
  <div class="sticky border-b border-slate-200 bg-slate-50 md:top-20">
    <div class="mx-auto max-w-[88rem] px-4 lg:px-6">
      <div class="overflow-x-auto">
        <nav class="min-w-max flex items-center gap-5 py-2">
          <!-- Skeleton loader when loading -->
          <template
            v-if="collectionsStore.rootCollections.status === 'pending'"
          >
            <NSkeleton
              v-for="i in 8"
              :key="i"
              :style="{ width: `${60 + ((i * i + i) % 5) * 8}px` }"
              pulse
            />
          </template>
          <NuxtLinkLocale
            v-for="collection in collectionsStore.rootCollections.data"
            v-else
            :key="collection.id"
            :to="`/collections/${collection.id}/${collection.slug}`"
            class="whitespace-nowrap rounded-md py-2 text-sm text-black font-semibold transition-all duration-200 hover:bg-white first:pl0 hover:text-primary hover:shadow-sm"
          >
            {{ collection.name }}
          </NuxtLinkLocale>
        </nav>
      </div>
    </div>
  </div>
</template>
